import config from 'common/config'

export async function loadYSTextFont () {
  const link = document.createElement('link')

  link.href = config.origin + '/fonts/index.css'
  link.rel = 'stylesheet'

  document.head!.appendChild(link)
}
